import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const WOS_DEVICE_ID = 'b62318f4d79d0de7c5f36298';

const useWosCredentials = (iframeRef, wosUrl) => {
    const storedAccessToken = localStorage.getItem('iot_rocket_access_JWT');
    const accessToken = useSelector(state => state.authentication.accessJWT) || storedAccessToken;
    const workspaceLabel = localStorage.getItem('iot_rocket_workspace') || window.location.hostname.split('.')[0];
    const wosOrigin = new URL(wosUrl).origin;

    useEffect(() => {
        if (workspaceLabel === null) {
            return undefined;
        }

        const handleMessage = event => {
            const iframeWindow = iframeRef.current ? iframeRef.current.contentWindow : null;
            const message = event.data;
            const isFromIframe = iframeWindow !== null
                && event.source === iframeWindow
                && event.origin === wosOrigin;

            if (isFromIframe && message && message.type === 'credentialsRequest') {
                iframeWindow.postMessage({
                    type: 'credentials',
                    data: {
                        // Anonymous visitors (on QR codes) won't get an access token
                        // just the workspace and device id
                        token: accessToken,
                        deviceId: WOS_DEVICE_ID,
                        workspace: workspaceLabel
                    }
                }, wosOrigin);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [accessToken, iframeRef, workspaceLabel, wosOrigin]);
};

export default useWosCredentials;
